import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSidebarWideLeftArrow: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"sidebar-wide-left-arrow"} maskId="square-filled-radius-0-stroke-1-IconSidebarWideLeftArrow"><path fillRule="evenodd" clipRule="evenodd" d="M8 20H22V4H8V20ZM15.9571 9.5L13.4571 12L15.9571 14.5L15.25 15.2071L12.0429 12L15.25 8.79289L15.9571 9.5Z" fill="currentColor"/><path d="M7 4H2V20H7V4Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconSidebarWideLeftArrow;
